import Button from 'src/components/Button/Button';
import style from './LandingPage.module.scss';
import { useNavigate } from 'react-router-dom';
import { breakpoints, useBreakpoints } from 'src/hooks/useBreakpoints';

function LandingPage() {
    const navigate = useNavigate();
    const isMediumScreen = useBreakpoints(breakpoints.md);

    return (
        <div className={style.landingPage}>
            <div className="container">
                <div className="textPart">
                    <h1>Stake your $TADA now</h1>
                    <p>Stake any amount of TADA, get daily staking rewards.</p>
                    <Button onClick={() => navigate('/dashboard')}>Stake</Button>
                </div>
                {!isMediumScreen && (
                    <div className="illustrationPart">
                        <img src="assets/images/illustration-part1.png" alt="TADA illustration part 1" />
                        <img src="assets/images/illustration-part3.png" alt="TADA illustration part 3" />
                        <img src="assets/images/illustration-part2.png" alt="TADA illustration part 2" />
                    </div>
                )}
            </div>
            <div className="footer">
                <span>Based on MultiversX</span>
            </div>
        </div>
    );
}

export default LandingPage;
